import { z } from 'zod';
import { ActionSchema } from '../actions';

export const WebEmbedBlockSchema = z.object({
  id: z.string().min(1),
  type: z.literal('web_embed'),
  rect: z.object({
    x: z.number().int().nonnegative(),
    y: z.number().int().nonnegative(),
    w: z.number().int().positive(),
    h: z.number().int().positive()
  }),
  on: z.object({ tap: z.array(ActionSchema).optional() }).optional(),
  props: z.object({
    url: z.string().url().startsWith('https://'),
    timeout_s: z.number().int().min(1).max(60),
    fallback_text: z.string()
  })
});